const da = {
  // ============================================================
  // COMMON — Delt på tværs af hele applikationen
  // ============================================================
  common: {
    loading: 'Indlæser...',
    error: 'Fejl',
    save: 'Gem',
    cancel: 'Annuller',
    delete: 'Slet',
    edit: 'Rediger',
    create: 'Opret',
    add: 'Tilføj',
    remove: 'Fjern',
    close: 'Luk',
    confirm: 'Bekræft',
    apply: 'Anvend',
    reset: 'Nulstil',
    search: 'Søg',
    filter: 'Filtrer',
    clear: 'Ryd',
    back: 'Tilbage',
    next: 'Næste',
    previous: 'Forrige',
    submit: 'Indsend',
    update: 'Opdater',
    refresh: 'Opdater',
    export: 'Eksporter',
    import: 'Importer',
    download: 'Download',
    upload: 'Upload',
    print: 'Udskriv',
    copy: 'Kopier',
    yes: 'Ja',
    no: 'Nej',
    ok: 'OK',
    done: 'Færdig',
    select: 'Vælg',
    selectAll: 'Vælg Alle',
    deselectAll: 'Fravælg Alle',
    noResults: 'Ingen resultater fundet',
    noData: 'Ingen data tilgængelige',
    required: 'Påkrævet',
    optional: 'Valgfri',
    actions: 'Handlinger',
    details: 'Detaljer',
    overview: 'Oversigt',
    summary: 'Resumé',
    total: 'Total',
    all: 'Alle',
    none: 'Ingen',
    name: 'Navn',
    type: 'Type',
    status: 'Status',
    date: 'Dato',
    time: 'Tid',
    description: 'Beskrivelse',
    notes: 'Noter',
    comments: 'Kommentarer',
    category: 'Kategori',
    priority: 'Prioritet',
    nation: 'Nation',
    country: 'Land',
    email: 'E-mail',
    phone: 'Telefon',
    address: 'Adresse',
    location: 'Placering',
    coordinates: 'Koordinater',
    latitude: 'Breddegrad',
    longitude: 'Længdegrad',
    from: 'Fra',
    to: 'Til',
    createdAt: 'Oprettet',
    updatedAt: 'Opdateret',
    createdBy: 'Oprettet af',
    modifiedBy: 'Ændret af',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktiveret',
    disabled: 'Deaktiveret',
    showing: 'Viser',
    of: 'af',
    page: 'Side',
    perPage: 'pr. side',
    rows: 'rækker',
    items: 'elementer',
    results: 'resultater',
    sortBy: 'Sorter efter',
    ascending: 'Stigende',
    descending: 'Faldende',
    viewAll: 'Se Alle',
    viewDetails: 'Se Detaljer',
    goBack: 'Gå Tilbage',
    learnMore: 'Læs Mere',
    seeMore: 'Se Mere',
    showMore: 'Vis Mere',
    showLess: 'Vis Mindre',
    expandAll: 'Udvid Alle',
    collapseAll: 'Skjul Alle',
    copied: 'Kopieret!',
    saved: 'Gemt!',
    deleted: 'Slettet!',
    updated: 'Opdateret!',
    created: 'Oprettet!',
    success: 'Succes',
    warning: 'Advarsel',
    info: 'Information',
    danger: 'Fare',
    unknown: 'Ukendt',
    notAvailable: 'I/T',
    never: 'Aldrig',
    today: 'I dag',
    yesterday: 'I går',
    tomorrow: 'I morgen',
    now: 'Nu',
    ago: 'siden',
    justNow: 'lige nu',
    minutesAgo: '{{count}}m siden',
    hoursAgo: '{{count}}t siden',
    daysAgo: '{{count}}d siden',
    monthsAgo: '{{count}}mdr siden',
    id: 'ID',
    version: 'Version',
    language: 'Sprog',
    theme: 'Tema',
    darkMode: 'Mørk Tilstand',
    lightMode: 'Lys Tilstand',
    failedToLoad: 'Kunne ikke indlæse data',
    failedToSave: 'Kunne ikke gemme',
    failedToDelete: 'Kunne ikke slette',
    failedToUpdate: 'Kunne ikke opdatere',
    confirmDelete: 'Er du sikker på, at du vil slette dette?',
    confirmAction: 'Er du sikker?',
    unsavedChanges: 'Du har ikke-gemte ændringer. Er du sikker på, at du vil forlade siden?',
    pageNotFound: '404 - Side Ikke Fundet',
    pageNotFoundDesc: 'Den side, du leder efter, findes ikke.',
    backToDashboard: 'Tilbage til Dashboard',
    characters: 'tegn',
    maxCharacters: 'Maksimalt {{max}} tegn',
    remaining: '{{count}} resterende',
    selected: '{{count}} valgt',
    of_total: '{{count}} af {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Overskrift, sidepanel, menuer
  // ============================================================
  nav: {
    dashboard: 'Dashboard',
    requests: 'Anmodninger',
    transports: 'Transporter',
    myPatients: 'Mine Patienter',
    statistics: 'Statistik',
    flow: 'Flow',
    resources: 'Resources',
    exercise: 'Øvelse',
    administration: 'Administration',
    map: 'Kort',
    info: 'Information',
    users: 'Brugere',
    assets: 'Aktiver',
    hubs: 'Hubs',
    treatmentFacilities: 'Behandlingsfaciliteter',
    patientImport: 'Patientimport',
    assetTemplates: 'Aktivskabeloner',
    dayTemplates: 'Dagskabeloner',
    announcementTicker: 'Meddelelseslinje',
    exerciseStatistics: 'Øvelsesstatistik',
    settings: 'Indstillinger',
    auditLog: 'Revisionslog',
    exerciseControl: 'Øvelsesstyring',
    dataSync: 'Datasynkronisering',
    documentation: 'Dokumentation',
    support: 'Support',
    about: 'Om',
    assetContracts: 'Asset Contracts',
    notifications: 'Notifikationer',
    schedules: 'Køreplaner',
    capacityPlanning: 'Kapacitetsplanlægning',
    transportPlanning: 'Transportplanlægning',
    transportBooking: 'Transportbooking',
    flowDiagram: 'Flowdiagram',
    changePassword: 'Skift Adgangskode',
    missions: 'Missioner',
    startPoints: 'Startpunkter',
    hospital: 'Hospital',
  },

  // ============================================================
  // AUTH — Login, adgangskode, session
  // ============================================================
  auth: {
    login: 'Log ind',
    logout: 'Log ud',
    logoutNow: 'Log Ud Nu',
    loggingIn: 'Logger ind...',
    loginFailed: 'Login mislykkedes',
    email: 'E-mail',
    password: 'Adgangskode',
    username: 'Brugernavn',
    enterEmail: 'Indtast din e-mailadresse',
    enterPassword: 'Indtast din adgangskode',
    enterUsername: 'Indtast dit brugernavn',
    forgotPassword: 'Glemt adgangskode?',
    forgotPasswordTitle: 'Glemt Adgangskode',
    forgotPasswordDesc: 'Indtast dit brugernavn og din e-mailadresse. Hvis begge stemmer overens, vil administratorerne blive underrettet om at nulstille din adgangskode.',
    requestPasswordReset: 'Anmod om Nulstilling af Adgangskode',
    sending: 'Sender...',
    backToLogin: 'Tilbage til Login',
    pleaseWait: 'Vent venligst, før du prøver igen.',
    requestFailed: 'Anmodning mislykkedes',
    credentialsMatch: 'Hvis legitimationsoplysningerne stemmer overens, er administratorerne blevet underrettet.',
    forAccess: 'For adgang bedes du kontakte din systemadministrator.',
    changePassword: 'Skift Adgangskode',
    currentPassword: 'Nuværende Adgangskode',
    newPassword: 'Ny Adgangskode',
    confirmPassword: 'Bekræft Adgangskode',
    passwordChanged: 'Adgangskode ændret succesfuldt',
    passwordMismatch: 'Adgangskoderne stemmer ikke overens',
    passwordTooShort: 'Adgangskoden skal være mindst 8 tegn',
    changingPassword: 'Ændrer...',
    mustChangePassword: 'Du skal ændre din adgangskode, før du kan fortsætte.',
    sessionExpiring: 'Session Udløber',
    sessionExpireText: 'Din session udløber om <strong>{{time}}</strong>. Gem venligst dit arbejde og log ind igen for at fortsætte.',
    dismiss: 'Afvis',
    switchNation: 'Skift Nation',
    returnTo: 'Vend tilbage til {{nation}}',
    viewingAs: 'Du ser som',
    loggedInAs: 'logget ind som {{nation}}',
    trainingMode: 'KUN TIL TRÆNINGSFORMÅL',
    dedication: 'Skabt med kærlighed og dedikation til professionen',
  },

  // ============================================================
  // ROLES — Brugerroller og etiketter
  // ============================================================
  roles: {
    admin: 'Systemadministrator',
    excon: 'Øvelseskontrollør',
    eu: 'EU-koordinator',
    planner: 'Planlægger',
    hub: 'Hub-ansvarlig',
    nation: 'Nation',
    readOnly: 'Skrivebeskyttet',
    systemAdmin: 'Systemadministrator',
    transportPlanner: 'Transportplanlægger',
    systemRoles: 'Systemroller',
  },

  // ============================================================
  // STATUS — Anmodnings-, tilbuds-, missionsstatus
  // ============================================================
  status: {
    draft: 'Kladde',
    underReview: 'Under Gennemgang',
    published: 'Offentliggjort',
    underSelection: 'Under Udvælgelse',
    accepted: 'Accepteret',
    planned: 'Planlagt',
    inTransit: 'Under Transport',
    completed: 'Afsluttet',
    closed: 'Lukket',
    withdrawn: 'Trukket Tilbage',
    pending: 'Afventer',
    rejected: 'Afvist',
    cancelled: 'Annulleret',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    review: 'Gennemgang',
    selection: 'Udvælgelse',
    transit: 'Transport',
  },

  // ============================================================
  // CATEGORIES — Anmodningskategorier
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personel',
    material: 'Materiel',
    equipment: 'Udstyr',
    other: 'Andet',
    news: 'Nyheder',
  },

  // ============================================================
  // URGENCY — Hastighedsniveauer
  // ============================================================
  urgency: {
    routine: 'Rutine',
    priority: 'Prioritet',
    urgent: 'Hastende',
    immediate: 'Øjeblikkelig',
  },

  // ============================================================
  // ASSETS — Transportaktivtyper
  // ============================================================
  assetTypes: {
    train: 'Tog',
    ship: 'Skib',
    aircraft: 'Fly',
    bus: 'Bus',
    ambulance: 'Ambulance',
    drone: 'Drone',
    helicopter: 'Helikopter',
    ferry: 'Færge',
    other: 'Andet',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Godmorgen',
    goodAfternoon: 'God eftermiddag',
    goodEvening: 'Godaften',
    lastLogin: 'Seneste login',
    infrastructure: 'Infrastruktur',
    transportAssets: 'Transportaktiver',
    treatmentFacilities: 'Behandlingsfaciliteter',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Anmodningsstatistik',
    viewAllRequests: 'Se alle anmodninger',
    availableAssets: 'Tilgængelige Aktiver',
    seated: 'Siddende',
    lying: 'Liggende',
    intensive: 'Intensiv',
    notifications: 'Notifikationer',
    markAllRead: 'Markér alle som læst',
    noNotifications: 'Ingen notifikationer endnu',
    notifiedWhenActivity: 'Du vil blive notificeret, når der er ny aktivitet',
    viewDetailsBtn: 'Se Detaljer',
    nationUsers: 'Nationsbrugere',
    user: 'Bruger',
    roles: 'Roller',
    noUsersFound: 'Ingen brugere fundet',
    participatingNations: 'Deltagende Nationer',
    exerciseDisclaimer: 'Dette system er udelukkende til øvelsesbrug. Indtast kun simulerede øvelsesdata. Arbejdsgangene er tilpasset øvelsesscenariet og kan afvige fra virkelige procedurer. IT-sikkerhed og databeskyttelsesregler gælder fortsat fuldt ud.',
    notConfigured: 'Ikke konfigureret',
    requestCount: '{{count}} anmodning(er)',
    clickToView: 'Klik for at se',
    systemAdministration: 'Systemadministration',
    exerciseControlTitle: 'Øvelsesstyring',
    euCoordination: 'EU-koordination',
    transportPlanningTitle: 'Transportplanlægning',
    hubManagement: 'Hub-styring',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Ny Anmodning',
    myDrafts: 'Mine Kladder',
    pendingReview: 'Afventer Gennemgang',
    activeTransports: 'Aktive Transporter',
    myPatients: 'Mine Patienter',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Anmodninger',
    newRequest: 'Ny Anmodning',
    createRequest: 'Opret Anmodning',
    editRequest: 'Rediger Anmodning',
    requestDetail: 'Anmodningsdetalje',
    requestId: 'Anmodnings-ID',
    fromNation: 'Fra Nation',
    toNation: 'Til Nation',
    requestingNation: 'Anmodende Nation',
    receivingNation: 'Modtagende Nation',
    category: 'Kategori',
    urgency: 'Hastighed',
    status: 'Status',
    patients: 'Patienter',
    patientCount: 'Antal Patienter',
    offers: 'Tilbud',
    offerCount: 'Antal Tilbud',
    created: 'Oprettet',
    updated: 'Opdateret',
    submittedBy: 'Indsendt af',
    reviewedBy: 'Gennemgået af',
    description: 'Beskrivelse',
    medicalDetails: 'Medicinske Detaljer',
    transportDetails: 'Transportdetaljer',
    additionalInfo: 'Yderligere Information',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Afgangspunkt',
    arrivalPoint: 'Ankomstpunkt',
    estimatedDeparture: 'Forventet Afgang',
    estimatedArrival: 'Forventet Ankomst',
    submitForReview: 'Indsend til Gennemgang',
    publish: 'Offentliggør',
    startSelection: 'Start Udvælgelse',
    acceptOffer: 'Accepter Tilbud',
    markInTransit: 'Markér Under Transport',
    markCompleted: 'Markér Afsluttet',
    closeRequest: 'Luk Anmodning',
    withdrawRequest: 'Træk Anmodning Tilbage',
    withdraw: 'Træk Tilbage',
    revertToDraft: 'Vend Tilbage til Kladde',
    deleteRequest: 'Slet Anmodning',
    duplicateRequest: 'Dupliker Anmodning',
    createFollowUp: 'Opret konsolideret anmodning',
    followUpRequest: 'Konsolideret anmodning',
    parentRequest: 'Oprindelig anmodning',
    childRequests: 'Konsoliderede anmodninger',
    noRequests: 'Ingen anmodninger fundet',
    noOffers: 'Ingen tilbud endnu',
    addPatient: 'Tilføj Patient',
    removePatient: 'Fjern Patient',
    patientDetails: 'Patientdetaljer',
    contactPerson: 'Kontaktperson',
    contactPhone: 'Kontakttelefon',
    contactEmail: 'Kontakt-e-mail',
    specialRequirements: 'Særlige Krav',
    medicalEquipment: 'Medicinsk Udstyr',
    accompaniment: 'Ledsagelse',
    timeline: 'Tidslinje',
    history: 'Historik',
    addComment: 'Tilføj Kommentar',
    writeComment: 'Skriv en kommentar...',
    postComment: 'Send Kommentar',
    posting: 'Sender...',
    noComments: 'Ingen kommentarer endnu',
    coverageBar: 'Dækning',
    covered: 'dækket',
    uncovered: 'udækket',
    filterByStatus: 'Filtrer efter status',
    filterByCategory: 'Filtrer efter kategori',
    filterByNation: 'Filtrer efter nation',
    searchRequests: 'Søg i anmodninger...',
    confirmWithdraw: 'Er du sikker på, at du vil trække denne anmodning tilbage?',
    confirmDelete: 'Er du sikker på, at du vil slette denne anmodning?',
    confirmPublish: 'Er du sikker på, at du vil offentliggøre denne anmodning? Den vil være synlig for alle nationer.',
    confirmStartSelection: 'Er du sikker på, at du vil starte udvælgelsen? Nationer vil kunne afgive tilbud.',
    warningStartSelection: 'Start af udvælgelsen vil gøre denne anmodning synlig for alle deltagende nationer. De vil kunne indsende tilbud for patienterne i denne anmodning. Denne handling kan ikke fortrydes.',
    warningMakeOffer: 'Ved at indsende dette tilbud forpligter du din nation til at yde den foreslåede assistance. Denne handling vil underrette den anmodende nation og øvelsesstyringen.',
    saveDraft: 'Gem Kladde',
    saving: 'Gemmer...',
    saveAndSubmit: 'Gem og Indsend',
    step: 'Trin {{number}}',
    generalInfo: 'Generel Information',
    patientInfo: 'Patientinformation',
    logisticsInfo: 'Logistikinformation',
    reviewSubmit: 'Gennemgå og Indsend',
    requestTitle: 'Anmodningstitel',
    requestDescription: 'Anmodningsbeskrivelse',
    numberOfPatients: 'Antal Patienter',
    typeOfAssistance: 'Type Assistance',
    medicalTreatment: 'Medicinsk Behandling',
    transportAssistance: 'Transportassistance',
    both: 'Begge',
    treatmentOnly: 'Kun Behandling',
    transportOnly: 'Kun Transport',
    validationErrors: 'Ret venligst følgende fejl:',
    fieldRequired: 'Dette felt er påkrævet',
    selectExitHub: 'Vælg en udgangshub',
    createExitHub: 'Opret Udgangshub',
    backToRequests: 'Tilbage til Anmodninger',
    noRequestsFound: 'Ingen anmodninger fundet',
    createFirstRequest: 'Opret din første anmodning for at komme i gang',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Tilbud',
    createOffer: 'Opret Tilbud',
    makeOffer: 'Afgiv Tilbud',
    manageOffers: 'Administrer Tilbud',
    offerDetail: 'Tilbudsdetalje',
    offerId: 'Tilbuds-ID',
    offeringNation: 'Tilbydende Nation',
    offerType: 'Tilbudstype',
    treatment: 'Behandling',
    transport: 'Transport',
    combined: 'Kombineret',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Behandlingstilbud',
    transportOffer: 'Transporttilbud',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Vælg Patienter',
    selectedPatients: 'Valgte Patienter',
    patientSelection: 'Patientudvælgelse',
    offerConfiguration: 'Tilbudskonfiguration',
    reviewOffer: 'Gennemgå Tilbud',
    submitOffer: 'Indsend Tilbud',
    submitting: 'Indsender...',
    acceptOffer: 'Accepter Tilbud',
    rejectOffer: 'Afvis Tilbud',
    withdrawOffer: 'Træk Tilbud Tilbage',
    noOffers: 'Ingen tilbud tilgængelige',
    noOffer: 'No Offer',
    offerStatus: 'Tilbudsstatus',
    offerDate: 'Tilbudsdato',
    transportAsset: 'Transportaktiv',
    departureDate: 'Afgangsdato',
    arrivalDate: 'Ankomstdato',
    treatmentFacility: 'Behandlingsfacilitet',
    capacity: 'Kapacitet',
    availableCapacity: 'Tilgængelig Kapacitet',
    totalCapacity: 'Total Kapacitet',
    selectAsset: 'Vælg Aktiv',
    selectFacility: 'Vælg Facilitet',
    offerNotes: 'Tilbudsnoter',
    confirmAccept: 'Er du sikker på, at du vil acceptere dette tilbud?',
    confirmReject: 'Er du sikker på, at du vil afvise dette tilbud?',
    extendTransport: 'Forlæng Transport',
    transportExtension: 'Transportforlængelse',
    comparisonView: 'Sammenligningsvisning',
    shortlist: 'Shortlist',
    addToShortlist: 'Tilføj til Shortlist',
    removeFromShortlist: 'Fjern fra Shortlist',
    leaveConfirmTitle: 'Forlade denne side?',
    leaveConfirmMessage: 'Du har ikke-gemte ændringer. Er du sikker på, at du vil forlade siden?',
    stayOnPage: 'Bliv på Siden',
    leavePage: 'Forlad Siden',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporter',
    missionDetail: 'Transportdetalje',
    missionId: 'Transport-ID',
    missionStatus: 'Transportstatus',
    createMission: 'Opret Transport',
    overview: 'Oversigt',
    patientsTab: 'Patienter',
    transportsTab: 'Transportetaper',
    treatmentTab: 'Behandling',
    reviewTab: 'Gennemgang',
    departure: 'Afgang',
    arrival: 'Ankomst',
    origin: 'Oprindelse',
    destination: 'Destination',
    stops: 'Stop',
    addStop: 'Tilføj Stop',
    removeStop: 'Fjern Stop',
    stopName: 'Stopnavn',
    stopType: 'Stoptype',
    estimatedTime: 'Forventet Tid',
    actualTime: 'Faktisk Tid',
    asset: 'Aktiv',
    driver: 'Fører',
    crew: 'Besætning',
    noMissions: 'Ingen transporter fundet',
    completeMission: 'Afslut Transport',
    cancelMission: 'Annuller Transport',
    startTransport: 'Start Transport',
    missionChain: 'Transportkæde',
    linkedMissions: 'Tilknyttede Transporter',
    handover: 'Overdragelse',
    handoverPoint: 'Overdragelsespunkt',
    pickupPoint: 'Afhentningspunkt',
    dropoffPoint: 'Afleveringspunkt',
    searchTransports: 'Søg i transporter...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patienter',
    myPatients: 'Mine Patienter',
    patientId: 'Patient-ID',
    firstName: 'Fornavn',
    lastName: 'Efternavn',
    dateOfBirth: 'Fødselsdato',
    age: 'Alder',
    gender: 'Køn',
    male: 'Mand',
    female: 'Kvinde',
    other: 'Andet',
    nationality: 'Nationalitet',
    diagnosis: 'Diagnose',
    condition: 'Tilstand',
    stable: 'Stabil',
    critical: 'Kritisk',
    serious: 'Alvorlig',
    treatmentNeeded: 'Behandling Påkrævet',
    allergies: 'Allergier',
    medications: 'Medicin',
    bloodType: 'Blodtype',
    weight: 'Vægt (kg)',
    infectious: 'Smitsom',
    mentalHealth: 'Mental Sundhed',
    mobility: 'Mobilitet',
    ambulatory: 'Oppegående',
    wheelchair: 'Kørestol',
    stretcher: 'Båre',
    intensive: 'Intensiv Pleje',
    oxygenRequired: 'Iltbehov',
    ventilator: 'Respirator',
    medicalEscort: 'Medicinsk Ledsager',
    noPatients: 'Ingen patienter fundet',
    patientDetails: 'Patientdetaljer',
    medicalHistory: 'Sygehistorik',
    travelDocuments: 'Rejsedokumenter',
    passport: 'Pas',
    pseudonymizedId: 'Pseudonymiseret ID',
    sensitiveData: 'Følsomme Data',
    journey: 'Patientforløb',
    assignedTo: 'Tildelt til',
    currentLocation: 'Nuværende Placering',
    importPatients: 'Importer Patienter',
    exportPatients: 'Eksporter Patienter',
    seated: 'Siddende',
    lying: 'Liggende',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Brugere',
    createUser: 'Opret Bruger',
    editUser: 'Rediger Bruger',
    deleteUser: 'Slet Bruger',
    username: 'Brugernavn',
    displayName: 'Visningsnavn',
    email: 'E-mail',
    password: 'Adgangskode',
    role: 'Rolle',
    roles: 'Roller',
    nation: 'Nation',
    active: 'Aktiv',
    lastLogin: 'Seneste Login',
    createdAt: 'Oprettet',
    isNation: 'Nation',
    isEU: 'EU',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planlægger',
    isHub: 'Hub',
    isReadOnly: 'Skrivebeskyttet',
    noUsers: 'Ingen brugere fundet',
    confirmDelete: 'Er du sikker på, at du vil slette denne bruger?',
    resetPassword: 'Nulstil Adgangskode',
    generatePassword: 'Generer Adgangskode',
    searchUsers: 'Søg i brugere...',
    userCreated: 'Bruger oprettet succesfuldt',
    userUpdated: 'Bruger opdateret succesfuldt',
    userDeleted: 'Bruger slettet succesfuldt',
    selectNation: 'Vælg en nation',
    mustChangePassword: 'Skal ændre adgangskode ved næste login',
    flagImage: 'Flagbillede',
    exportUsers: 'Eksporter Brugere',
    importUsers: 'Importer Brugere',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Aktiver',
    createAsset: 'Opret Aktiv',
    editAsset: 'Rediger Aktiv',
    deleteAsset: 'Slet Aktiv',
    assetName: 'Aktivnavn',
    assetType: 'Aktivtype',
    capacitySeated: 'Kapacitet (Siddende)',
    capacityLying: 'Kapacitet (Liggende)',
    capacityIntensive: 'Kapacitet (Intensiv)',
    owner: 'Ejer',
    operator: 'Operatør',
    baseLocation: 'Basisplacering',
    range: 'Rækkevidde',
    speed: 'Hastighed',
    noAssets: 'Ingen aktiver fundet',
    confirmDelete: 'Er du sikker på, at du vil slette dette aktiv?',
    searchAssets: 'Søg i aktiver...',
    assetCreated: 'Aktiv oprettet succesfuldt',
    assetUpdated: 'Aktiv opdateret succesfuldt',
    assetDeleted: 'Aktiv slettet succesfuldt',
    exportAssets: 'Eksporter Aktiver',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubs',
    startPoints: 'Startpunkter',
    createHub: 'Opret Hub',
    editHub: 'Rediger Hub',
    deleteHub: 'Slet Hub',
    hubName: 'Hub-navn',
    hubType: 'Hub-type',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Indgangshub',
    airport: 'Lufthavn',
    seaport: 'Havn',
    railStation: 'Togstation',
    roadPoint: 'Vejpunkt',
    ucpmClassification: 'UCPM-klassifikation',
    icaoCode: 'ICAO-kode',
    iataCode: 'IATA-kode',
    noHubs: 'Ingen hubs fundet',
    confirmDelete: 'Er du sikker på, at du vil slette denne hub?',
    searchHubs: 'Søg i hubs...',
    nationAssignment: 'Nationstildeling',
    assignNations: 'Tildel Nationer',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Behandlingsfaciliteter',
    createFacility: 'Opret Facilitet',
    editFacility: 'Rediger Facilitet',
    deleteFacility: 'Slet Facilitet',
    facilityName: 'Facilitetsnavn',
    facilityType: 'Facilitetstype',
    hospitalName: 'Hospitalsnavn',
    bedCapacity: 'Sengekapacitet',
    specialties: 'Specialer',
    availableBeds: 'Tilgængelige Senge',
    totalBeds: 'Senge i Alt',
    contactPerson: 'Kontaktperson',
    noFacilities: 'Ingen behandlingsfaciliteter fundet',
    confirmDelete: 'Er du sikker på, at du vil slette denne facilitet?',
    searchFacilities: 'Søg i faciliteter...',
    hubNationAssignment: 'Hub-nationstildeling',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Køreplaner',
    createSchedule: 'Opret Køreplan',
    editSchedule: 'Rediger Køreplan',
    deleteSchedule: 'Slet Køreplan',
    scheduleName: 'Køreplansnavn',
    scheduleType: 'Køreplanstype',
    recurring: 'Tilbagevendende',
    oneTime: 'Engangs',
    frequency: 'Frekvens',
    daily: 'Daglig',
    weekly: 'Ugentlig',
    startDate: 'Startdato',
    endDate: 'Slutdato',
    departureTime: 'Afgangstid',
    arrivalTime: 'Ankomsttid',
    stops: 'Stop',
    addStop: 'Tilføj Stop',
    noSchedules: 'Ingen køreplaner fundet',
    bookings: 'Bookinger',
    timeline: 'Tidslinje',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notifikationer',
    markAllRead: 'Markér alle som læst',
    markAsRead: 'Markér som læst',
    markAsUnread: 'Markér som ulæst',
    noNotifications: 'Ingen notifikationer',
    viewAll: 'Se Alle Notifikationer',
    settings: 'Notifikationsindstillinger',
    emailNotifications: 'E-mailnotifikationer',
    inAppNotifications: 'In-app-notifikationer',
    notifyOn: 'Underret mig om',
    requestCreated: 'Ny Anmodning',
    requestPublished: 'Anmodning Offentliggjort',
    requestClosed: 'Anmodning Lukket',
    requestCompleted: 'Anmodning Afsluttet',
    commentAdded: 'Ny Kommentar',
    offerReceived: 'Tilbud Modtaget',
    offerAccepted: 'Tilbud Accepteret',
    statusChanged: 'Status Ændret',
    selectionStarted: 'Udvælgelse Startet',
    missionCreated: 'Transport Oprettet',
    missionStatusUpdated: 'Transport Opdateret',
    transportPartnerNamed: 'Transportpartner',
    transportExtensionReceived: 'Transportforlængelse',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Indstillinger',
    general: 'Generelt',
    system: 'System',
    email: 'E-mail',
    sync: 'Synkronisering',
    security: 'Sikkerhed',
    appearance: 'Udseende',
    systemName: 'Systemnavn',
    systemEmail: 'System-e-mail',
    maintenanceMode: 'Vedligeholdelsestilstand',
    readOnlyMode: 'Skrivebeskyttet Tilstand',
    emailEnabled: 'E-mail Aktiveret',
    smtpHost: 'SMTP-server',
    smtpPort: 'SMTP-port',
    smtpUser: 'SMTP-bruger',
    smtpPassword: 'SMTP-adgangskode',
    senderEmail: 'Afsender-e-mail',
    senderName: 'Afsendernavn',
    testEmail: 'Send Test-e-mail',
    syncEnabled: 'Synkronisering Aktiveret',
    syncUrl: 'Synkroniserings-URL',
    syncApiKey: 'Synkroniserings-API-nøgle',
    settingsSaved: 'Indstillinger gemt succesfuldt',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Helpdesk-titel',
    helpdeskEmail: 'Helpdesk-e-mail',
    helpdeskPhone: 'Helpdesk-telefon',
    helpdeskInfo: 'Helpdesk-information',
    realLifeSupport: 'Support i Virkeligheden',
    trainingMode: 'Træningstilstand',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Revisionslogge',
    action: 'Handling',
    user: 'Bruger',
    target: 'Mål',
    details: 'Detaljer',
    timestamp: 'Tidsstempel',
    ipAddress: 'IP-adresse',
    noLogs: 'Ingen revisionslogge fundet',
    searchLogs: 'Søg i logge...',
    filterByAction: 'Filtrer efter handling',
    filterByUser: 'Filtrer efter bruger',
    exportLogs: 'Eksporter Logge',
    exportCsv: 'Eksporter CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Øvelsesstyring',
    currentDay: 'Aktuel Dag',
    exerciseDay: 'Øvelsesdag',
    nextDay: 'Næste Dag',
    previousDay: 'Forrige Dag',
    resetExercise: 'Nulstil Øvelse',
    startExercise: 'Start Øvelse',
    endExercise: 'Afslut Øvelse',
    dayReset: 'Dagsnulstilling',
    confirmReset: 'Er du sikker på, at du vil nulstille øvelsesdagen? Dette vil slette alle data for den aktuelle dag.',
    resetInProgress: 'Nulstilling i gang...',
    maintenanceMode: 'Vedligeholdelsestilstand',
    enableMaintenance: 'Aktiver Vedligeholdelse',
    disableMaintenance: 'Deaktiver Vedligeholdelse',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Datasynkronisering',
    syncStatus: 'Synkroniseringsstatus',
    lastSync: 'Seneste Synkronisering',
    pendingItems: 'Afventende Elementer',
    syncNow: 'Synkroniser Nu',
    syncing: 'Synkroniserer...',
    syncSuccess: 'Synkronisering gennemført succesfuldt',
    syncFailed: 'Synkronisering mislykkedes',
    outbox: 'Udbakke',
    inbox: 'Indbakke',
    configuration: 'Konfiguration',
    targetUrl: 'Mål-URL',
    apiKey: 'API-nøgle',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Kort',
    layers: 'Lag',
    requests: 'Anmodninger',
    hubs: 'Hubs',
    facilities: 'Faciliteter',
    routes: 'Ruter',
    showAll: 'Vis Alle',
    hideAll: 'Skjul Alle',
    zoomIn: 'Zoom Ind',
    zoomOut: 'Zoom Ud',
    resetView: 'Nulstil Visning',
    satellite: 'Satellit',
    terrain: 'Terræn',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Kortfliser serveres lokalt',
    tilesOnline: 'Kortfliser indlæses fra onlineservere',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistik',
    overview: 'Oversigt',
    requestsByStatus: 'Anmodninger efter Status',
    requestsByCategory: 'Anmodninger efter Kategori',
    requestsByNation: 'Anmodninger efter Nation',
    offersByStatus: 'Tilbud efter Status',
    patientsByCondition: 'Patienter efter Tilstand',
    transportsByStatus: 'Transporter efter Status',
    timeline: 'Tidslinje',
    totalRequests: 'Anmodninger i Alt',
    totalOffers: 'Tilbud i Alt',
    totalPatients: 'Patienter i Alt',
    totalTransports: 'Transporter i Alt',
    averageResponseTime: 'Gennemsnitlig Svartid',
    completionRate: 'Fuldførelsesrate',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Øvelsesstatistik',
    overview: 'Oversigt',
    byCategory: 'Efter Kategori',
    byNation: 'Efter Nation',
    byDay: 'Efter Dag',
    totalPatientsMoved: 'Patienter Flyttet i Alt',
    totalRequestsProcessed: 'Anmodninger Behandlet i Alt',
    averageProcessingTime: 'Gennemsnitlig Behandlingstid',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Flowdiagram',
    sankey: 'Sankey',
    nodeGraph: 'Knudegraf',
    refresh: 'Opdater',
    noData: 'Ingen flowdata tilgængelige',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Om',
    version: 'Version',
    systemInfo: 'Systeminformation',
    buildDate: 'Byggedato',
    environment: 'Miljø',
    description: 'ARCOS — Avanceret Anmodningskommunikationssystem',
    subtitle: 'Pårørendeassistance og Medicinske Operationer',
    whatIsArcos: 'Hvad er ARCOS? – Forklaring til øvelsesdeltagere',
    arcosDesc1: 'ARCOS er et digitalt værktøj, der bruges i denne øvelse til at støtte og strukturere international kommunikation, anmodninger og koordineringsprocesser mellem de deltagende aktører.',
    arcosDesc2: 'ARCOS giver en forenklet, øvelsesorienteret repræsentation af de grundlæggende principper bag disse systemer.',
    arcosUsedFor: 'Under øvelsen bruges ARCOS til at repræsentere typiske processer som:',
    arcosUsedForItem1: 'indsendelse og styring af anmodninger om assistance,',
    arcosUsedForItem2: 'koordinering af og svar på støttetilbud fra andre nationer,',
    arcosUsedForItem3: 'sporing af status og fremdrift af anmodninger,',
    arcosUsedForItem4: 'og repræsentation af forenklede transport- eller evakueringsarbejdsgange.',
    arcosDesc3: 'Arbejdsgangene i ARCOS er bevidst forenklede og tilpasset øvelsens specifikke træningsmål.',
    arcosDesc4: 'Målet med ARCOS er ikke at simulere et perfekt eller komplet virkeligt system.',
    arcosDesc5: 'Hvis visse elementer afviger fra virkelige procedurer, du kender, er dette forventet.',
    facilitatedBy: 'Faciliteret af MMCC-E',
    dhcInitiative: 'Digital Health Corner (DHC) er et fælles initiativ af:',
    dhcAuthor1: 'Sven Giegerich — Tyske Forsvar',
    dhcAuthor2: 'Mohamad Haji — Belgisk Forsvar',
    dhcConviction: 'Født af overbevisningen om, at innovation trives, hvor passion møder pragmatisme.',
    dhcInspired: 'Inspireret af MMCC-E satte vi os for at skabe enkle men effektive løsninger.',
    dhcLove: 'Vi gør det, fordi vi elsker vores arbejde og tror på, at digitale ideer kan omforme samarbejdet inden for militær sundhed.',
    dhcOpen: 'DHC er en åben platform: fri for hierarkier, åben for ideer, drevet af nysgerrighed.',
    dhcClosing: 'Digital Health Corner – hvor nysgerrighed møder samarbejde.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentation',
    gettingStarted: 'Kom i Gang',
    userGuide: 'Brugervejledning',
    faq: 'Ofte Stillede Spørgsmål',
    troubleshooting: 'Fejlfinding',
    apiReference: 'API-reference',
    downloadTemplate: 'Download Skabelon',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Patientimport',
    uploadFile: 'Upload Fil',
    selectFile: 'Vælg Fil',
    preview: 'Forhåndsvisning',
    importNow: 'Importer Nu',
    importing: 'Importerer...',
    importSuccess: '{{count}} patienter importeret succesfuldt',
    importFailed: 'Import mislykkedes',
    downloadTemplate: 'Download Skabelon',
    dragDrop: 'Træk og slip en fil her, eller klik for at vælge',
    supportedFormats: 'Understøttede formater: XLSX, XLS, CSV',
    rowsFound: '{{count}} rækker fundet',
    validRows: '{{count}} gyldige rækker',
    invalidRows: '{{count}} ugyldige rækker',
    duplicateRows: '{{count}} duplikerede rækker',
    previewData: 'Forhåndsvis Data',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transportplanlægning',
    planRoute: 'Planlæg Rute',
    routeBuilder: 'Rutebygger',
    addWaypoint: 'Tilføj Mellemstation',
    removeWaypoint: 'Fjern Mellemstation',
    estimatedDuration: 'Forventet Varighed',
    distance: 'Afstand',
    selectVehicle: 'Vælg Køretøj',
  },

  transportBooking: {
    title: 'Transportbooking',
    bookTransport: 'Book Transport',
    availableSlots: 'Tilgængelige Pladser',
    bookingConfirmed: 'Booking Bekræftet',
    cancelBooking: 'Annuller Booking',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapacitetsplanlægning',
    totalCapacity: 'Total Kapacitet',
    usedCapacity: 'Brugt Kapacitet',
    availableCapacity: 'Tilgængelig Kapacitet',
    utilizationRate: 'Udnyttelsesgrad',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Aktivskabeloner',
    dayTemplates: 'Dagskabeloner',
    createTemplate: 'Opret Skabelon',
    editTemplate: 'Rediger Skabelon',
    deleteTemplate: 'Slet Skabelon',
    templateName: 'Skabelonnavn',
    applyTemplate: 'Anvend Skabelon',
    noTemplates: 'Ingen skabeloner fundet',
    confirmDelete: 'Er du sikker på, at du vil slette denne skabelon?',
    confirmApply: 'Er du sikker på, at du vil anvende denne skabelon? Dette vil overskrive eksisterende data.',
    exportTemplates: 'Eksporter Skabeloner',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Meddelelseslinje',
    createAnnouncement: 'Opret Meddelelse',
    editAnnouncement: 'Rediger Meddelelse',
    deleteAnnouncement: 'Slet Meddelelse',
    message: 'Meddelelse',
    startTime: 'Starttid',
    endTime: 'Sluttid',
    active: 'Aktiv',
    noAnnouncements: 'Ingen meddelelser',
    confirmDelete: 'Er du sikker på, at du vil slette denne meddelelse?',
  },

  // ============================================================
  // COMPONENTS — Genbrugelige komponenttekster
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Søg...',
      noResults: 'Ingen resultater fundet',
      showing: 'Viser {{from}} til {{to}} af {{total}}',
      rowsPerPage: 'Rækker pr. side',
      previousPage: 'Forrige side',
      nextPage: 'Næste side',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Bekræft',
      cancel: 'Annuller',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Ikke-gemte Ændringer',
      message: 'Du har ikke-gemte ændringer. Er du sikker på, at du vil forlade denne side?',
      stay: 'Bliv på Siden',
      leave: 'Forlad Siden',
    },
    // EmptyState
    emptyState: {
      noData: 'Ingen data tilgængelige',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Noget gik galt',
      message: 'Der opstod en uventet fejl. Prøv venligst at genindlæse siden.',
      retry: 'Prøv Igen',
    },
    // ExportButton
    exportButton: {
      export: 'Eksporter',
      exporting: 'Eksporterer...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Udskriv',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Kladde',
      review: 'Gennemgang',
      published: 'Offentliggjort',
      selection: 'Udvælgelse',
      inTransit: 'Under Transport',
      completed: 'Afsluttet',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online Instans',
      message: 'Skrivebeskyttet tilstand. Data synkroniseres fra den primære server.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Du ser som',
      loggedInAs: 'logget ind som {{nation}}',
      returnTo: 'Vend tilbage til {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Søg i sider, anmodninger, transporter...',
      searching: 'Søger...',
      noResults: 'Ingen resultater for "{{query}}"',
      navigate: 'Navigér',
      select: 'Vælg',
      close: 'Luk',
      pages: {
        dashboard: 'Dashboard',
        requests: 'Anmodninger',
        transports: 'Transporter',
        map: 'Kort',
        myPatients: 'Mine Patienter',
        flowDiagram: 'Flowdiagram',
        statistics: 'Statistik',
        assets: 'Aktiver',
        startPoints: 'Startpunkter / Hubs',
        treatmentFacilities: 'Behandlingsfaciliteter',
        users: 'Brugere',
        settings: 'Indstillinger',
        auditLogs: 'Revisionslogge',
        exerciseControl: 'Øvelsesstyring',
        dataSync: 'Datasynkronisering',
        patientImport: 'Patientimport',
        notifications: 'Notifikationer',
        documentation: 'Dokumentation',
      },
      actions: {
        importPatientsJson: 'Importér Patienter (JSON)',
        importPatientsExcel: 'Importér Patienter (Excel)',
        importUsers: 'Importér Brugere (Excel)',
        importAssetTemplates: 'Importér Aktivskabeloner (Excel)',
        importDayTemplates: 'Importér Dagsskabelonposter (Excel)',
        exportRequests: 'Eksportér Anmodninger (Excel)',
        exportPatients: 'Eksportér Patienter (Excel)',
        exportUsers: 'Eksportér Brugere (Excel)',
        exportCredentials: 'Eksportér Legitimationsoplysninger (PDF)',
        exportAuditExcel: 'Eksportér Revisionslog (Excel)',
        exportAuditPdf: 'Eksportér Revisionslog (PDF)',
        pagePatientImport: 'Side for patientimport',
        pageRequestDetail: 'Side for anmodningsdetaljer',
        pageUsers: 'Side for brugerstyring',
        pageAssetTemplates: 'Side for aktivskabeloner',
        pageDayTemplates: 'Side for dagsskabeloner',
        pageRequests: 'Side for anmodningsliste',
        pageAuditLogs: 'Side for revisionslog',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Session Udløber',
      message: 'Din session udløber om <strong>{{time}}</strong>. Gem venligst dit arbejde og log ind igen for at fortsætte.',
      dismiss: 'Afvis',
      logoutNow: 'Log Ud Nu',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Vælg 4 tidszoner',
      configure: 'Konfigurer tidszoner',
      reset: 'Nulstil',
      apply: 'Anvend',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Vælg Placering',
      latitude: 'Breddegrad',
      longitude: 'Længdegrad',
      clickToSelect: 'Klik på kortet for at vælge en placering',
    },
    // Modal
    modal: {
      close: 'Luk',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Hjem',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Systemvedligeholdelse',
    message: 'Systemet nulstilles til næste øvelsesdag. Vent venligst, indtil processen er fuldført.',
    autoRefresh: 'Denne side opdateres automatisk, når systemet er tilgængeligt igen.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Mindst 10 tegn',
    uppercase: '1 stort bogstav',
    lowercase: '1 lille bogstav',
    digit: '1 ciffer',
    special: '1 specialtegn',
  },
};

export default da;
